import { Segmented } from 'antd';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsComponent from '../components/settings';
import TransactionsLogsComponent from '../components/transactionsLogs';
import ApprovalsComponent from '../components/approvals';

const TransactionsLogsPage: FunctionComponent = () => {
	const { t } = useTranslation();

	const [selectedView, setSelectedView] = useState<string>('transaction_logs');

	const viewOptions = [
		{
			value: 'transaction_logs',
			label: (
				<p className="fw-medium mb-0" style={{ fontSize: 15 }}>
					{t('COMPANY_INFORMATION.TRANSACTIONS_LOGS')}
				</p>
			),
		},
		{
			value: 'approvals',
			label: (
				<p className="fw-medium mb-0" style={{ fontSize: 15 }}>
					{t('COMPANY_INFORMATION.APPROVALS')}
				</p>
			),
		},
		{
			value: 'settings',
			label: (
				<p className="fw-medium mb-0" style={{ fontSize: 15 }}>
					{t('COMPANY_INFORMATION.SETTINGS')}
				</p>
			),
		},
	];

	return (
		<>
			<Segmented
				block
				className="custom white"
				size="middle"
				options={viewOptions}
				onChange={(value) => {
					setSelectedView(value);
				}}
			/>

			{selectedView === 'transaction_logs' ? <TransactionsLogsComponent /> : selectedView === 'approvals' ? <ApprovalsComponent /> : <SettingsComponent />}
		</>
	);
};

export default TransactionsLogsPage;
